export default __webpack_public_path__ + "static/media/lines.left2.0592723a.png";